import { createAsyncThunk } from "@reduxjs/toolkit"
import {
  del,
  get,
  post,
  put,
} from "helpers/api_helper"
import {
  GET_ALL_STATIC_MAINTENANCE_LIST,
  GET_ALL_STATIC_MAINTENANCE,
  DELETE_STATIC_MAINTENANCE,
  ADD_STATIC_MAINTENANCE,
  UPDATE_STATIC_MAINTENANCE,
  GET_STATIC_MAINTENANCE_DETAILS
} from "helpers/url_helper"

export const getStaticMaintenanceList = createAsyncThunk(
  GET_ALL_STATIC_MAINTENANCE_LIST,
  async payload => {
    const response = await get(GET_ALL_STATIC_MAINTENANCE_LIST, payload)
    return response
  }
)

export const getStaticMaintenance = createAsyncThunk(
  GET_ALL_STATIC_MAINTENANCE,
  async payload => {
    const response = await post(GET_ALL_STATIC_MAINTENANCE, payload)
    return response
  }
)

export const deleteStaticMaintenance = createAsyncThunk(
  DELETE_STATIC_MAINTENANCE,
  async payload => {
    const response = await del(DELETE_STATIC_MAINTENANCE, payload)
    return response
  }
)

export const addStaticMaintenance = createAsyncThunk(ADD_STATIC_MAINTENANCE, async payload => {
  const response = await post(ADD_STATIC_MAINTENANCE, payload)
  return response
})

export const updateStaticMaintenance = createAsyncThunk(
  UPDATE_STATIC_MAINTENANCE,
  async payload => {
    const response = await put(UPDATE_STATIC_MAINTENANCE, payload)
    return response
  }
)

export const getStaticMaintenanceDetails = createAsyncThunk(
  GET_STATIC_MAINTENANCE_DETAILS,
  async payload => {
    const response = await post(GET_STATIC_MAINTENANCE_DETAILS, payload)
    return response
  }
)
